module.exports = __webpack_public_path__ + "static/media/22.03631c79.jpg";